import { requireOtcGuard } from '@/routes/guards/sso'

const SsoExchange = () => import('@/views/sso/ViewSsoExchange')

export default [
  {
    path: 'sso/exchange',
    name: 'SsoExchange',
    component: SsoExchange,
    props: true,
    meta: {
      requiresGuest: true
    },
    beforeEnter: to => requireOtcGuard({ to })
  }
]